import { isEmpty } from 'ramda';

import { USStatesDropDownOptions } from 'helpers/USMapStates';
import { Campaign } from 'scenes/Home/scenes/MerchantStatusDetails/scenes/sections/MerchantOffers/MerchantOffer.types';

type AccountDetails = {
  merchantUuid?: string;
  companyName: string;
  firstName: string;
  lastName: string;
  title: string;
  email: string;
  phone: string;
  category: string;
  subCategory?: string;
  pointOfSaleSystem?: string;
  address1: string;
  address2?: string;
  city: string;
  state: string;
  postal: string;
  latitude?: number;
  longitude?: number;
  numberOfStores?: number;
};

type PaymentInstruments = {
  preferred: boolean;
  properties: Properties;
};

type Billing = {
  paymentModel: string;
  paymentInstruments: PaymentInstruments;
};

type AutomaticRenewal = {
  enabled: boolean;
};

type BudgetPlan = {
  automaticRenewal: AutomaticRenewal;
  renewalTargetCents: number;
  estimatedNextRenewalDate: string;
};

type Renewal = {
  eventLoggedAt: string;
  merchantUuid: string;
  renewalStatus: string;
  renewalStartedAt: string;
  merchantCustomerProfileId: string;
  p: string;
  initialRequestToken: string;
  sagaStepEventId: string;
  s: string;
  sagaStepEvent: string;
  budgetRenewalId: string;
  orderReferenceId: string;
  sagaStep: string;
  paymentRequestUuid: string;
};

type Id = {
  type: string;
  value: string;
};

type Properties = {
  accountId: string;
  accountNickname: string;
  accountType: string;
  balance: number;
  bankHexColor?: string;
  institution: string;
  last4Digits: number;
  requestStatus: string;
};

type PreferredPaymentInstrument = {
  preferred: boolean;
  type: string;
  id: Id;
  properties: Properties;
};

type MerchantCustomerProfile = {
  merchantCustomerProfileId: string;
  merchantCustomerId: string;
  billing: Billing;
  budgetPlan: BudgetPlan;
  preferredPaymentInstrument: PreferredPaymentInstrument;
};

type PaymentDetails = {
  merchantCustomerProfile: MerchantCustomerProfile;
  mostRecentRenewal: Renewal;
  allRenewals: Renewal[];
};

const POSSystem = {
  options: [
    { key: 'select', value: null, text: 'Select' },
    {
      key: 'cardProcessing',
      value: 'Card Processing',
      text: 'Card Processing',
    },
    { key: 'stripe', value: 'Stripe', text: 'Stripe' },
    { key: 'clover', value: 'Clover', text: 'Clover' },
    { key: 'toast', value: 'Toast', text: 'Toast' },
    { key: 'shopifyPOS', value: 'Shopify POS', text: 'Shopify POS' },
    { key: 'lightspeed', value: 'Lightspeed', text: 'Lightspeed' },
    { key: 'square', value: 'Square', text: 'Square' },
  ],
  label: {
    children: 'Transaction Type',
  },
  placeholder: 'Select your Point of Sale system',
};

const USStates = {
  options: USStatesDropDownOptions,
  label: {
    children: 'State',
  },
  placeholder: 'State',
};

const RequiredFieldMsg = 'This field is required';

const formatEventLog = (allRenewals: Renewal[], monthlyPayment: number) => {
  if (isEmpty(allRenewals)) return [];

  const filteredEvents: Renewal[] = [];
  allRenewals.map((renewal: any) => {
    if (renewal.events[0].sagaStep === 'COMPLETED_RENEWAL') {
      renewal.monthlyPayment = monthlyPayment;
      filteredEvents.push(renewal);
    }
  });
  return filteredEvents;
};

export {
  AccountDetails,
  Campaign,
  MerchantCustomerProfile,
  PaymentDetails,
  PreferredPaymentInstrument,
  Renewal,
  POSSystem,
  USStates,
  RequiredFieldMsg,
  formatEventLog,
};
